const iconPrefix = 'mdi'

export const defaultIconMapping = {
  account: `${iconPrefix}-account-check-outline`,
  anniversary: `${iconPrefix}-seal-variant`,
  arrow_bottom: `${iconPrefix}-chevron-down`,
  arrow_left: `${iconPrefix}-chevron-left`,
  arrow_right: `${iconPrefix}-chevron-right`,
  arrow_right_long: `${iconPrefix}-arrow-right`,
  attachment: `${iconPrefix}-link-variant`,
  back_to_top: `${iconPrefix}-arrow-back-to-top`,
  birthday: `${iconPrefix}-cake`,
  chat_filled: `${iconPrefix}-forum`,
  check: `${iconPrefix}-check`,
  close: `${iconPrefix}-close`,
  comment: `${iconPrefix}-comment-outline`,
  comment_filled: `${iconPrefix}-comment`,
  download: `${iconPrefix}-download-outline`,
  download_circle: `${iconPrefix}-download-circle-outline`,
  dummy: `${iconPrefix}-account-hard-hat`,
  emotions: `${iconPrefix}-emoticon-happy-outline`,
  error: `${iconPrefix}-alert`,
  facebook: 'social-media-icon-facebook',
  fallback_group: `${iconPrefix}-account-group`,
  file: `${iconPrefix}-paperclip`,
  flickr: 'social-media-icon-flickr',
  googleplus: 'social-media-icon-googleplus',
  group: `${iconPrefix}-account-edit`,
  heart: `${iconPrefix}-heart-outline`,
  heart_filled: `${iconPrefix}-heart`,
  info: `${iconPrefix}-lightbulb-on-outline`,
  instagram: 'social-media-icon-instagram',
  lock: `${iconPrefix}-lock`,
  login: `${iconPrefix}-login-variant`,
  logout: `${iconPrefix}-logout-variant`,
  mail: `${iconPrefix}-email-open-outline`,
  members: `${iconPrefix}-account-multiple-outline`,
  minus: `${iconPrefix}-minus`,
  notification: `${iconPrefix}-bell-outline`,
  pen: `${iconPrefix}-playlist-edit`,
  person: `${iconPrefix}-account`,
  plus: `${iconPrefix}-plus`,
  refresh: `${iconPrefix}-refresh`,
  rss: 'social-media-icon-rss',
  search: `${iconPrefix}-magnify`,
  settings: `${iconPrefix}-cog-outline`,
  slider_separator: `${iconPrefix}-checkbox-blank-circle`,
  star: `${iconPrefix}-star-outline`,
  star_filled: `${iconPrefix}-star`,
  star_half: `${iconPrefix}-star-half-full`,
  submit: `${iconPrefix}-arrow-right`,
  subpages_default: `${iconPrefix}-lightbulb-on-outline`,
  trash: `${iconPrefix}-trash-can-outline`,
  tumblr: 'social-media-icon-tumblr',
  twitter: 'social-media-icon-twitter',
  upload: `${iconPrefix}-cloud-upload-outline`,
  webnews_default: 'social-media-icon-webnews-default',
  youtube: 'social-media-icon-youtube',
}
export const iconMapping = icon => {return defaultIconMapping[icon]}
